//Importación de librerias
//---------------SICSEN---------------
//Catalogos
import C003TiposResoluciones from '../../../src/components/SICSEN/Catalogos/C003TiposResoluciones.vue';

//Creamos y asignamos los datos necesarios de SICPO
const sicsen = [
    { Proviene: 'SICSEN', Nombre: 'C003TiposResoluciones', datos: C003TiposResoluciones }
]

export default sicsen;


//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/sicsen.js
// module id = null
// module chunks = 